import { FC } from 'react';
import { useSignal } from '@preact/signals-react';
import { FaEye } from 'react-icons/fa';
import PresentationModal from '../../organisms/PresentationModal';
import ATable from '../../organisms/ATable';
import ScriptModal from './ScriptModal';

export interface FieldItem {
    header: string;
    field: string;
    value?: string | number | null;
    script?: string;
}

interface FieldsModalProps {
    id: string;
    show: boolean;
    fields: FieldItem[];
    onClose: () => void;
    /** optional row values to show field values */
    row?: Record<string, any> | null;
}

const FieldsModal: FC<FieldsModalProps> = ({ id, show, fields, onClose, row }) => {
    const showScript = useSignal(false);
    const currentScript = useSignal('');

    const openScript = (script: string) => {
        currentScript.value = script;
        showScript.value = true;
    };

    const valueHeaders = [
        { id: 'field', title: 'Campo', canSort: false },
        { id: 'value', title: 'Valor', canSort: false },
    ];

    const definitionHeaders = [
        { id: 'header', title: 'Cabeçalho', canSort: false },
        { id: 'field', title: 'Campo', canSort: false },
        { id: 'script', title: '', canSort: false, width: '40px' },
    ];

    return (
        <>
            <PresentationModal id={id} show={show} onClose={onClose} header="Campos" height="500px">
                <div className="p-4">
                    <div style={{ height: '500px', overflowY: 'auto' }}>
                        <ATable
                            headers={
                                fields.length > 0 && fields[0].value !== undefined
                                    ? valueHeaders
                                    : definitionHeaders
                            }
                            autoResize={false}
                        >
                            {fields.length > 0 && fields[0].value !== undefined
                                ? fields.map((f, index) => (
                                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                                        <td className="px-2 py-1 border-b">{f.header}</td>
                                        <td className="px-2 py-1 border-b">{f.value ?? '-'}</td>
                                    </tr>
                                ))
                                : fields.map((fieldItem, index) => (
                                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                                        <td className="px-2 py-1 border-b">{fieldItem.header}</td>
                                        <td className="px-2 py-1 border-b">{fieldItem.field}</td>
                                        <td className="px-2 py-1 border-b text-center">
                                            {fieldItem.script && (
                                                <button
                                                    aria-label="Visualizar script"
                                                    className="text-blue-600"
                                                    onClick={() => openScript(fieldItem.script!)}
                                                >
                                                    <FaEye />
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                        </ATable>
                    </div>
                </div>
            </PresentationModal>
            <ScriptModal id={`${id}-script`} show={showScript.value} script={currentScript.value} onClose={() => (showScript.value = false)} />
        </>
    );
};

export default FieldsModal;
